import { Box, Button, TextField, styled } from '@mui/material';

import { flexMixin } from 'utils/flexMixin';

export const DocumentHeader = styled(Box)({
	...flexMixin({ gap: 24 }),
	width: '100%',
});
export const SearchField = styled(TextField)({
	border: 'none',
	height: '44px',
	width: '100%',
	textTransform: 'none',
	fontSize: '16px',
	fontWeight: '700',
	gap: '8px',

	'& fieldset': { border: 'none' },
	'& input': {
		padding: '10px 12px 10px 0',

		'&::placeholder': { color: '#8790A0', opacity: 1 },
	},
});
export const AddDocumentButton = styled(Button)({
	...flexMixin({ gap: 10 }),
	padding: '10px 16px',
	borderRadius: '8px',
	maxWidth: '210px',
	width: '100%',
	boxSizing: 'border-box',

	textTransform: 'unset',
	fontSize: '16px',
	fontWeight: '700',
	lineHeight: ' 157%',
	letterSpacing: '0.1px',
	color: '#4786FF',
});

export const VisuallyHiddenInput = styled('input')({
	clip: 'rect(0 0 0 0)',
	clipPath: 'inset(50%)',
	height: 1,
	overflow: 'hidden',
	position: 'absolute',
	bottom: 0,
	left: 0,
	whiteSpace: 'nowrap',
	width: 1,
});
